<template>
    <div id="app" style="overflow-y: auto">
        <!-- 路由 -->
        <videoPopover v-show="xiaoduPic" :xiaoduPic="xiaoduPic" :deviceXiaodu="deviceXiaodu"></videoPopover>
        <transition :name="transitionName">
            <!-- <transition> -->
            <router-view class="router-view" style="height: 100%;overflow: hidden;"></router-view>
        </transition>
        <div v-if="showApp">
            <div>
                <msg
                        v-show="dialogsVisibleMsg == true"
                        @close="Dialogclose"
                        style="left: 40px; bottom: 30px"
                ></msg>
            </div>
            <div>
                <lymsg
                        v-show="dialogsVisible == true"
                        @lyclose="Dialogsclose"
                        style="left: 40px; bottom: 30px"
                ></lymsg>
            </div>
            <div>
                <tymsg
                        v-show="dialogsVisibleTy == true"
                        @tyclose="DialogTyclose"
                        style="left: 40px; bottom: 30px"
                ></tymsg>
            </div>
            <div>
                <jhlmsg
                        v-show="dialogsVisibleJhl == true"
                        @jhlclose="DialogJhlclose"
                        style="left: 40px; bottom: 30px"
                ></jhlmsg>
            </div>
        </div>

    </div>
</template>

<script>
    import "@/assets/font/font.css"
    import msg from "@/components/msg.vue"
    import videoPopover from "@/components/videoPopover.vue"
    import lymsg from "@/components/lymsg.vue"
    import tymsg from "@/components/tymsg.vue"
    import jhlmsg from "@/components/jhlmsg.vue"
    import exportVue from "@/utils/exportVue"
    import WaterMark from '@/utils/waterMark.js'

    export default {
        components: {
            msg,
            lymsg,
            tymsg,
            jhlmsg,
            videoPopover
        },
        data() {
            return {
                showApp: true,
                routeName: "", //当前展示子路由的路由名称
                transitionName: "", //定义过渡动画名称
                // dialogVisible: false,
                dialogsVisible: false,
                dialogsVisibleMsg: false,
                dialogsVisibleTy: false,
                dialogsVisibleJhl: false,
                xiaoduPic: false,
                deviceXiaodu: {},
                waterMark: null,
                arr: [444, 449, 450, 451, 452, 453, 454, 459],
                // msglist: [{ id: 0, rights: "40", bottoms: "30" }],
                // rights: 40,
                // dataIndex: 0,
                // bottoms: 30,
            }
        },
        created() {
            this.getPageUrl()
            // 在页面加载时读取localStorage里的状态信息
            if (localStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(localStorage.getItem("store"))
                    )
                )
                localStorage.removeItem("store")
            }
            // 在页面刷新时将vuex里的信息保存到localStorage里
            window.addEventListener("pagehide", () => {
                localStorage.setItem("store", JSON.stringify(this.$store.state))
            })
        },
        mounted() {
            this.$bus.on("log", value => {
                 this.showMark();
            });
            this.$bus.on("xiaoduPic", value => {
                this.xiaoduPic = value;
            });

            this.$bus.on("deviceXiaodu", value => {
                this.deviceXiaodu = value;
            });
            this.$bus.on('alarmMsg', value => {
                if (value) {
                    this.showApp = true;
                } else {
                    this.showApp = false;
                }
            });
        },
        updated() {
            this.getPageUrl()
        },
        methods: {
            containsSegment(arr, segment) {
                for (let i = 0; i < segment.length; i++) {
                    if (!arr.includes(segment[i])) {
                        return false;
                    }
                }
                return true;
            },
            showMark() {
                let name = sessionStorage.getItem("name")
                let dataIds = this.$store.state.dataIds;
                this.containsSegment(dataIds, this.arr)
                if (this.containsSegment(dataIds, this.arr)) {
                    this.waterMark = null;
                    return;
                } else {
                    this.waterMark = new WaterMark({
                        // watermark_txt: '禾康' +this.$store.state.info.name, // 水印的内容
                        watermark_txt: `${name}`, // 水印的内容
                        watermark_x: 40, // 水印起始位置x轴坐标
                        watermark_y: 40, // 水印起始位置Y轴坐标
                        watermark_rows: 0, // 水印行数
                        watermark_cols: 0, // 水印列数
                        watermark_x_space: 40, // 水印x轴间隔
                        watermark_y_space: 40, // 水印y轴间隔
                        watermark_width: 150, // 水印宽度
                        watermark_height: 80, // 水印长度
                        watermark_angle: 315, // 水印倾斜度数
                        monitor: false,
                    });
                }
            },
            // 获取当前页面路由名称
            getPageUrl() {
                this.routeName = this.$route.name
            },
            Dialogclose(data) {
                if (this.showApp) {
                    this.dialogsVisibleMsg = data
                    exportVue.$emit("istrue", data)
                }
            },
            Dialogsclose(data) {
                if (this.showApp) {
                    this.dialogsVisible = data
                    exportVue.$emit("isTrue", data)
                }
            },
            DialogTyclose(data) {
                if (this.showApp) {
                    this.dialogsVisibleTy = data
                    exportVue.$emit("isTrue", data)
                }
            },
            DialogJhlclose(data) {
                console.log(data)
                if (this.showApp) {
                    this.dialogsVisibleJhl = data
                    exportVue.$emit("isTrue", data)
                }
            },
        },
        watch: {
            //使用watch 监听$router子路由的变化
            $route(to, from) {
                //如果to索引大于from索引,判断为前进状态,反之则为后退状态
                // to.meta.index : 旧页面的路由meta 在router.js中定义的
                // 通过判断新旧页面的路由meta数值,来对应加载前进后退动画
                if (to.meta.index > from.meta.index) {
                    //设置动画名称
                    this.transitionName = "slide-left"
                } else {
                    this.transitionName = "slide-right"
                }
                this.$store.commit("current", to.path)
            },
            showApp(newValue,oldValue) {
                this.showApp = newValue;
            }
        }
    }
</script>
<style lang="less" scoped>
    /deep/ .amap-marker-label {
        width: auto;
        height: 20px;
        line-height: 20px;
    }

    @import "./assets/css/sectionBox.css";
    #app {
        position: relative;
    }
    // 路由切换的动画样式
    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
        will-change: transform;
        transition: all 500ms;
        position: absolute;
    }

    .slide-right-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }

    .slide-right-leave-active {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .slide-left-enter {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .slide-left-leave-active {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }

    //弹窗样式
    // /deep/ .el-dialog__body {
    //     padding-top: 30px !important;
    // }

    /* 解决element-ui的table表格控件表头与内容列不对齐问题 */
    /deep/ .el-table th.gutter {
        display: table-cell;
    }

    /deep/ .el-input__suffix {
        margin-top: 0px;
    }

    /deep/ .el-input.is-disabled .el-input__inner {
        color: #3f3f40;
    }

    /deep/ .localtion_hover {
        width: 174px;
        height: 98px;
        padding: 12px 16px;
        box-sizing: border-box;
        background: url(./assets/img/bigData/meal/window_bg_.png) no-repeat center /
    100% 100%;

        ul li {
            margin-bottom: 6px;
            font-size: 14px;

            &:nth-last-child(1) {
                margin-bottom: 0;
            }
        }
    }

    /deep/ .windowInfo {
        padding: 10px 15px;
        border-radius: 8px;
        background: #fff;
        border: #f0f0f0 1px solid;
        color: #333;
        font-size: 16px;
    }

    /deep/ .amap-marker-label {
        border: none;
        background-color: transparent;

    }

    /deep/ .amap-sug-result {
        z-index: 9999 !important;
        visibility: visible !important;
    }

    ::v-deep .el-upload-list__item {
        transition: none !important;
    }
</style>
